import TimelineAccess from '@/models/TimelineAccess';
import ProjectServer from '../../models/ProjectServer'
export class CreateFolderArgs
{
    public name = '';
    public description = '';
}

export class UpdateFolderDataArgs
{
    public id = 0;
    public name = '';
    public description = '';
}

export class DeleteFolderArgs
{
    public id = 0;
}

export class SetTimelineFolderArgs
{
    folderid : number | null = null;
    timelineid = -1;
}

export class SetUserPermissionArgs
{
    public folderid = 0;
    public userid = '';
    public permissions = 0;
}

const Folder_Create_RPC = "Folder_Create";
const Folder_UpdateData_RPC = "Folder_UpdateData";
const Folder_Delete_RPC = "Folder_Delete";
const Folder_SetTimelineFolder_RPC = "Folder_SetTimelineFolder";
const Folder_GetAllPermissions_RPC = "Folder_GetAllPermissions";
const Folder_SetUserPermissions_RPC = "Folder_SetUserPermissions";
export class FolderRequests
{
    static async Folder_Create(args: CreateFolderArgs)
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<number, CreateFolderArgs>(Folder_Create_RPC, args);
    }

    static async Folder_UpdateData(args: UpdateFolderDataArgs)
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<number, UpdateFolderDataArgs>(Folder_UpdateData_RPC, args);
    }

    static async Folder_Delete(args: DeleteFolderArgs)
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<number, DeleteFolderArgs>(Folder_Delete_RPC, args);
    }

    static async Folder_SetTimelineFolder(args: SetTimelineFolderArgs)
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<void, SetTimelineFolderArgs>(Folder_SetTimelineFolder_RPC, args);
    }
    
    static async Folder_GetAllPermissions(args: {folderid: number})
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<TimelineAccess[], number>(Folder_GetAllPermissions_RPC, args.folderid);
    }

    static async Folder_SetUserPermissions(args: SetUserPermissionArgs)
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<void, SetUserPermissionArgs>(Folder_SetUserPermissions_RPC, args);
    }
}